import { Sentry } from './sentry.lib';
import {
    type AssetTelemetryAttributes,
    type TelemetryAttributes,
    type TelemetryLogAttributesByName,
    type TelemetryLogName,
    addCommonTelemetryAttributes,
    flattenTelemetryAttributes,
} from './telemetry-attributes.lib';

export { TELEMETRY_LOGS } from './telemetry-attributes.lib';
export type { ModalOpenedTelemetryAttributes, ShareType } from './telemetry-attributes.lib';

export type TelemetryLogLevel = 'info' | 'warn' | 'error';

let assetTelemetryContext: AssetTelemetryAttributes = {};

export const setAssetTelemetryContext = (asset?: AssetTelemetryAttributes): void => {
    assetTelemetryContext = asset ?? {};
};

const addAssetTelemetryContext = (attributes: TelemetryAttributes): TelemetryAttributes => {
    if (
        !assetTelemetryContext.id &&
        !assetTelemetryContext.orderType &&
        !assetTelemetryContext.status &&
        !assetTelemetryContext.type &&
        !assetTelemetryContext.viewContext
    ) {
        return attributes;
    }

    return {
        ...attributes,
        asset: {
            ...assetTelemetryContext,
            ...attributes.asset,
        },
    };
};

export const logTelemetry = <Name extends TelemetryLogName>(
    level: TelemetryLogLevel,
    name: Name,
    attributes: TelemetryLogAttributesByName[Name]
): void => {
    try {
        const telemetryAttributes = addCommonTelemetryAttributes(addAssetTelemetryContext(attributes));
        const logAttributes = flattenTelemetryAttributes(telemetryAttributes);

        if (level === 'info') {
            Sentry.logger.info(name, logAttributes);
            return;
        }

        if (level === 'warn') {
            Sentry.logger.warn(name, logAttributes);
            return;
        }

        Sentry.logger.error(name, logAttributes);
    } catch {
        return;
    }
};

export const addTelemetryBreadcrumb = (category: string, message: string, attributes: TelemetryAttributes): void => {
    try {
        const telemetryAttributes = addCommonTelemetryAttributes(addAssetTelemetryContext(attributes));

        Sentry.addBreadcrumb({
            category,
            data: flattenTelemetryAttributes(telemetryAttributes),
            level: 'info',
            message,
        });
    } catch {
        return;
    }
};
